// extracted by mini-css-extract-plugin
export default {"body":"Resultados_body__xn4I+","content":"Resultados_content__eOAf-","side":"Resultados_side__-HuZh","searchForm":"Resultados_searchForm__O1hWM","label":"Resultados_label__FZWDj"};